// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/workspace.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from message omnios.v1.Workspace
 */
export const Workspace = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.Workspace",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "settings", kind: "message", T: Struct },
    { no: 5, name: "features", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "avatar_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.ListWorkspacesRequest
 */
export const ListWorkspacesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListWorkspacesRequest",
  [],
);

/**
 * @generated from message omnios.v1.ListWorkspacesResponse
 */
export const ListWorkspacesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListWorkspacesResponse",
  () => [
    { no: 1, name: "workspaces", kind: "message", T: Workspace, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetWorkspaceRequest
 */
export const GetWorkspaceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetWorkspaceRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateWorkspaceRequest
 */
export const CreateWorkspaceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateWorkspaceRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "settings", kind: "message", T: Struct },
    { no: 4, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.UpdateWorkspaceRequest
 */
export const UpdateWorkspaceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateWorkspaceRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "settings", kind: "message", T: Struct },
    { no: 5, name: "features", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "update_features", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.DeleteWorkspaceRequest
 */
export const DeleteWorkspaceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteWorkspaceRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.UploadWorkspaceAvatarRequest
 */
export const UploadWorkspaceAvatarRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UploadWorkspaceAvatarRequest",
  () => [
    { no: 1, name: "data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "mime_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ReportProblemRequest
 */
export const ReportProblemRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ReportProblemRequest",
  () => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ReportProblemResponse
 */
export const ReportProblemResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ReportProblemResponse",
  () => [
    { no: 1, name: "issue_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

